/** @type {import('@nuxt/types').Plugin} */
export default (ctx, inject) => {
    /** @type {OfferWeb.CDFPlugin} */
    const cdf = {
        async sendEvent(event, userId) {
            /** @type {OfferWeb.OfferStoreState} */
            const state = ctx.store.state;

            await ctx.$tracking.triggerCDFEvent({
                event,
                extraData: {
                    userId,
                    geo: state.country ?? '',
                    previousRoute: state.previousRoute ?? '',
                    currentRoute: ctx.route.path,
                    experimentationIdentifier: ctx.$experimentRelay?.getOrCreateExperimentationID() ?? undefined,
                },
            });
        },
    };

    inject('cdf', cdf);
};
